import { fetcher } from 'src/config/request';
import { UserProfileEndpoints } from './endpoints';
export const UserProfileService = {
    async getUser() {
        const { data } = await fetcher.get(UserProfileEndpoints.getUser());
        return data;
    }
};
